import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ContactCycleRuleRequest, ContactCycleRuleResponse, PageResponse } from '../models/contact-cycle-rule.model';

@Injectable({
  providedIn: 'root'
})
export class ContactCycleRuleApiService {
  private readonly apiUrl = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) { }

  // GET /api/contact-cycle-rules?businessId=&cycleId=&page=&size= (paginado desde v1.16)
  getRules(businessId: number, cycleId?: number, page = 0, size = 100): Observable<ContactCycleRuleResponse[]> {
    let params = new HttpParams()
      .set('businessId', businessId.toString())
      .set('page', page.toString())
      .set('size', size.toString());
    if (cycleId !== undefined) {
      params = params.set('cycleId', cycleId.toString());
    }
    return this.http.get<PageResponse<ContactCycleRuleResponse>>(`${this.apiUrl}/contact-cycle-rules`, { params })
      .pipe(map(res => res.content));
  }

  // GET /api/contact-cycle-rules/{id}?businessId=
  getRuleById(id: number, businessId: number): Observable<ContactCycleRuleResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<ContactCycleRuleResponse>(`${this.apiUrl}/contact-cycle-rules/${id}`, { params });
  }

  // POST /api/contact-cycle-rules
  createRule(rule: ContactCycleRuleRequest): Observable<ContactCycleRuleResponse> {
    return this.http.post<ContactCycleRuleResponse>(`${this.apiUrl}/contact-cycle-rules`, rule);
  }

  // PUT /api/contact-cycle-rules/{id}
  updateRule(id: number, rule: ContactCycleRuleRequest): Observable<ContactCycleRuleResponse> {
    return this.http.put<ContactCycleRuleResponse>(`${this.apiUrl}/contact-cycle-rules/${id}`, rule);
  }

  // DELETE /api/contact-cycle-rules/{id}?businessId=
  deleteRule(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.apiUrl}/contact-cycle-rules/${id}`, { params });
  }
}
